/* eslint-disable react/jsx-props-no-spreading */
import React, { useState } from 'react';
import { Box, IconButton } from '@chakra-ui/react';
import { useFormState } from 'react-final-form';
import {
  DetailsEvent,
  InfoEventBrief,
  InfoIcon,
  ModalPage,
  Paper,
} from 'components';
import { FormValues, MasterInfo, ServiceInfo, SpecialistCases } from 'types';
import { TitleStlyed } from './styles';
import { Time } from './Time';

export const EventInfo: React.FC<{
  address: string;
  master?: MasterInfo;
  service?: ServiceInfo;
  widgetId?: string;
  date?: Date;
  specialistCases: SpecialistCases;
}> = ({ address, master, service, widgetId, date, specialistCases }) => {
  const {
    values: { groupEventInfo },
  } = useFormState<FormValues>();

  // Детальная информация по событию
  const [isShowDetails, setShowDetails] = useState(false);
  const closeDetails = () => setShowDetails(false);

  const handleOpenDetailsEvent = (
    e: React.MouseEvent<HTMLElement, MouseEvent>,
  ) => {
    setShowDetails(true);
    e.stopPropagation();
  };

  return (
    <>
      <ModalPage
        isOpen={isShowDetails}
        title="О событии"
        onClose={closeDetails}
      >
        {isShowDetails && (
          <DetailsEvent
            widgetId={widgetId}
            event={groupEventInfo}
            master={master}
            service={service}
            specialistCases={specialistCases}
          />
        )}
      </ModalPage>

      <Paper my="4">
        <Time
          duration={
            service?.showDuration !== false ? groupEventInfo.duration : 0
          }
          day={date}
        />
        {address && (
          <Box mt={2}>
            <TitleStlyed>Адрес</TitleStlyed>
            <div translate="no">{address}</div>
          </Box>
        )}
      </Paper>
      <Paper>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <Box>
            <InfoEventBrief event={groupEventInfo} service={service} />
          </Box>
          <IconButton
            rounded="full"
            variant="ghost"
            icon={<InfoIcon />}
            aria-label="Просмотр события"
            onClick={handleOpenDetailsEvent}
          />
        </Box>
      </Paper>
    </>
  );
};
